import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import BusinessProfileSetup from './BusinessProfileSetup.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/chatlotta'),
      component: SettingsWrapper,
      meta: {
        permissions: ['administrator'],
      },
      children: [
        {
          path: '',
          name: 'chatlotta_business_profile_settings',
          component: BusinessProfileSetup,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
